import { render, staticRenderFns } from "./FormGroupSelectSearchableWithTags.vue?vue&type=template&id=2c871513"
import script from "./FormGroupSelectSearchableWithTags.vue?vue&type=script&lang=js"
export * from "./FormGroupSelectSearchableWithTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports